import React, { useRef, useContext } from 'react';
import styled from '@emotion/styled';

import { DispatchContext } from '@store/store';
import { closeTeamInviteInfoModal } from '@store/actions';

function TeamInfoModal({ state }) {
  const dispatch = useContext(DispatchContext);
  const ModalRef = useRef(null);

  function closeModal() {
    window.history.pushState({}, null, '/');
    dispatch(closeTeamInviteInfoModal());
  }

  return (
    <TeamInfoModalWrapper id="teamInfoContainer" ref={ModalRef}>
      <div className="team-info-container">
        <button onClick={closeModal} className="team-info-close-btn">
          <img
            src="https://d1nc6vzg2bevln.cloudfront.net/images/general/cross.svg"
            alt=""
          />
        </button>
        <div className="team-info-body">
          <p className="team-info-header">You’ve been invited to a team!</p>
          <p className="team-info-desc">
            Please log in via desktop for more details
          </p>
          <button onClick={closeModal} className="team-info-btn">
            Got it!
          </button>
        </div>
      </div>
    </TeamInfoModalWrapper>
  );
}

export default TeamInfoModal;

const TeamInfoModalWrapper = styled.div`
  .team-info-container {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #fff;
    z-index: 10001;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 0px 25px;
  }

  .team-info-close-btn {
    float: right;
    margin: 15px -15px 18px 0px;
    padding: 5px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 50%;
  }

  .team-info-body {
    margin-top: 60px;
  }

  .team-info-header {
    font-family: Inter;
    font-weight: 700;
    font-size: 22px;
  }

  .team-info-desc {
    font-family: Inter;
    font-weight: 400;
    font-size: 16px;
    margin-top: 10px;
  }

  .team-info-btn {
    margin: 40px 0px 30px;
    display: flex;
    justify-content: center;
    width: 100%;
    background: #3399ff;
    padding: 10px 0px;
    border-radius: 25px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
  }
`;
